import { MdModeEdit } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const IconEdit = styled(MdModeEdit)`
  display: flex;
  min-width: 24px;
  min-height: 24px;
  margin-left: 8px;
`;

export const Container = styled.div`
  padding: 12px 15px;
  background-color: rgba(${ColorPalette.RGB.BrightGray9}, 0.3);
  border: 1px solid rgba(${ColorPalette.RGB.BrightGray}, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Field = styled.div`
  display: flex;
  place-self: flex-start;
  line-height: 1.5em;
  font-size: 16px;
  margin: auto 0;
`;

export const Placeholder = styled.span`
  color: ${ColorPalette.HEX.SonicSilver2};
  font-size: 16px;
`;
